import Loader from "components/Loader/loader"
import Breadcrumb from "components/Common/Breadcrumb"
import Configs from "../../config"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaEye,
  FaSearch,
} from "react-icons/fa"
import { MdCancel, MdCheckCircle } from "react-icons/md"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"

const Expense = () => {
  const [loading, setLoading] = useState(false)
  const [expenses, setExpenses] = useState([])

  const [searchString, setSearchString] = useState("")
  const [perPageItem, setPerPageItem] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const getAllExpenses = async () => {
    setLoading(true)
    try {
      const response = await fetchData(setLoading, "expense")
      if (response?.success) {
        setExpenses(response.data.reverse() || [])
      } else {
        Swal.fire(
          "Error",
          response?.message || "Failed to load Expenses",
          "error"
        )
      }
    } catch (err) {
      console.error(err)
      Swal.fire("Error", "Network or server error", "error")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAllExpenses()
  }, [])

  const filteredExpense = useMemo(() => {
    if (!searchString.trim()) return expenses

    const lowerSearch = searchString.toLowerCase()

    return expenses.filter(expense => {
      return (
        expense.type?.toLowerCase().includes(lowerSearch) ||
        expense?.employee?.name?.toLowerCase().includes(lowerSearch) ||
        expense.amount?.toLowerCase().includes(lowerSearch) ||
        expense.vat?.toLowerCase().includes(lowerSearch) ||
        expense.note?.toLowerCase().includes(lowerSearch)
      )
    })
  }, [expenses, searchString])

  const totalItems = filteredExpense.length
  const totalPages = Math.ceil(totalItems / perPageItem)

  const indexOfLastItem = currentPage * perPageItem
  const indexOfFirstItem = indexOfLastItem - perPageItem
  const currentexpenses = filteredExpense.slice(
    indexOfFirstItem,
    indexOfLastItem
  )

  const [receiptModal, setReceiptModal] = useState(false)
  const [selectedImg, setSelectedIMG] = useState("")

  const handleApprove = async (id, status) => {
    const result = await Swal.fire({
      title: `Are you sure?`,
      text:
        status === true
          ? "You want to approve this expense"
          : "You want to reject this expense",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: status === true ? "Yes, Approve" : "Yes, Reject",
    })

    if (!result.isConfirmed) return

    const APIdata = await FetchPutData(setLoading, "expense", id, {
      status,
    })

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Expense Status Updated",
        text: APIdata?.data?.message,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      })
      getAllExpenses()
    } else {
      Swal.fire({
        title: "Error Updating Expense",
        text:
          APIdata?.response?.data?.message ||
          "Something went wrong, please try again",
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {/* <PermittedComponent isAccess={checkAccess(3, 1) || checkAccess(3, 2)}> */}
      <Container fluid>
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem="Employee Expenses"
          description="Manage the all Employees Expenses from Here."
        />
        {loading && <Loader />}
        <Row>
          <Col lg="12" className="px-0">
            <Card className="mb-0 shadow-lg">
              <CardBody>
                {/* Controls */}
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="position-relative">
                      <input
                        className="form-control rounded-4 ps-3 pe-5"
                        placeholder="Search by Employee , Enpense Type..."
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                      <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>

                    <select
                      className="form-select rounded-4 w-auto"
                      value={perPageItem}
                      onChange={e => setPerPageItem(Number(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                </div>

                {/* expenses Table */}
                <Table responsive hover className="align-middle">
                  <thead className="bg-blue text-white">
                    <tr>
                      <th>#</th>
                      <th>Employee Name</th>
                      <th>Expense Type</th>
                      <th>Total Amount</th>
                      <th>VAT</th>
                      <th>Status</th>
                      <th>Note</th>
                      <th className="text-center">Receipt</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentexpenses.length === 0 ? (
                      <tr>
                        <td colSpan={9} className="text-center text-muted py-4">
                          No Expenses found
                        </td>
                      </tr>
                    ) : (
                      currentexpenses.map((expense, idx) => (
                        <tr key={expense.id}>
                          <td>{indexOfFirstItem + idx + 1}</td>
                          <td>
                            <strong>{expense?.employee?.name}</strong>
                          </td>

                          <td>{expense.type || "—"}</td>
                          <td>£ {expense?.totalAmount}</td>
                          <td>£ {expense?.vat}</td>
                          <td
                            className={`fw-bold ${
                              expense?.status === null
                                ? "text-warning"
                                : expense?.status === true
                                ? "text-success "
                                : "text-danger"
                            }`}
                          >
                            {expense?.status === null
                              ? "Pending"
                              : expense?.status === true
                              ? "Approved "
                              : "Rejected"}
                          </td>
                          <td>{expense?.note}</td>
                          <td className="text-center">
                            <Button
                              className="btn-blue"
                              onClick={() => {
                                setReceiptModal(true),
                                  setSelectedIMG(expense?.receipt)
                              }}
                            >
                              <FaEye />
                            </Button>
                          </td>
                          <td className="text-center">
                            {expense?.status === null && (
                              <>
                                <Button
                                  className="btn-success me-2"
                                  onClick={() =>
                                    handleApprove(expense?.id, true)
                                  }
                                >
                                  <MdCheckCircle />
                                </Button>
                                <Button
                                  className="btn-danger"
                                  onClick={() =>
                                    handleApprove(expense?.id, false)
                                  }
                                >
                                  <MdCancel />
                                </Button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>

                {/* Pagination */}
                {totalItems > 0 && (
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
                    <div className="text-muted">
                      Showing {currentexpenses.length} of {totalItems} Expenses
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <Button
                        size="sm"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(p => p - 1)}
                      >
                        <FaChevronCircleLeft />
                      </Button>

                      {Array.from({ length: totalPages }, (_, i) => (
                        <Button
                          key={i}
                          size="sm"
                          color={currentPage === i + 1 ? "primary" : "light"}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </Button>
                      ))}

                      <Button
                        size="sm"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(p => p + 1)}
                      >
                        <FaChevronCircleRight />
                      </Button>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={receiptModal} centered>
        <ModalHeader toggle={() => setReceiptModal(false)}>
          Expense Receipt
        </ModalHeader>
        <ModalBody>
          {!selectedImg ? (
            <h6 className="text-center">No Image Found</h6>
          ) : (
            <img
              className="w-100 h-100 object-fit-cover"
              src={`${Configs.imageUrl}${selectedImg}`}
            />
          )}
        </ModalBody>
      </Modal>
      {/* </PermittedComponent> */}
    </div>
  )
}

export default Expense
